import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import CookieConsent from 'react-cookie-consent';
import ReactPiwik from 'react-piwik';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import {
  AttendeeView,
  ExhibitorView,
  HomeView,
  LoginView,
  MeetingOptInView,
  NotFoundView,
  PrintComponent,
  ProfileImageView,
  ScrollToTop,
} from 'C4';
import { demo, piwikSiteid } from 'settings';

const hashLinkScroll = () => {
  const { hash } = window.location;
  if (hash !== '') {
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
};

/**
 *
 * @param cookieName
 */
const cookieExists = (cookieName) => {
  const decodedCookies = decodeURIComponent(document.cookie);
  const splitCookies = decodedCookies.split(';');
  return splitCookies.includes(cookieName);
};

export default class AppRouter extends Component {
  constructor(props) {
    super(props);

    const piwik = new ReactPiwik({
      url: '//data.travpromobile.com/matomo',
      siteId: piwikSiteid,
      trackErrors: true,
    });
    ReactPiwik.push(['requireConsent']);
    ReactPiwik.push(['trackPageView']);

    this.state = {
      cookies: '',
    };

    this.CookieDecline = this.CookieDecline.bind(this);
    this.CookieAccept = this.CookieAccept.bind(this);
    this.showCookieBar = this.showCookieBar.bind(this);
  }

  componentWillMount() {
    if (cookieExists('cookieConsent=true') || cookieExists(' cookieConsent=true')) {
      this.setState({ cookies: 'accepted' });
      ReactPiwik.push(['rememberConsentGiven']);
    } else if (cookieExists('cookieConsent=false') || cookieExists(' cookieConsent=false')) {
      ReactPiwik.push(['forgetConsentGiven']);
    } else {
      this.showCookieBar();
    }
  }

  showCookieBar() {
    this.setState({ cookies: 'requiresConsent' });
  }

  CookieAccept() {
    this.setState({ cookies: 'accepted' });
    ReactPiwik.push(['rememberConsentGiven']);
    window.location.reload();
  }

  CookieDecline() {
    this.setState({ cookies: 'declined' });
    ReactPiwik.push(['forgetConsentGiven']);
    document.cookie = 'cookieConsent=false';
    window.location.reload();
  }

  render() {
    return (
      <BrowserRouter
        onUpdate={(e) => {
          hashLinkScroll(e);
        }}
        history={() => this.piwik.connectToHistory(History)}
      >
        <ScrollToTop>
          <div className="container">
            <Switch>
              {((window.location.hostname === 'virtualtravelxpos.com' || window.location.hostname === 'www.virtualtravelxpos.com') &&
                <Route path="/" exact component={HomeView} />
              )}
              {((window.location.hostname === 'localhost' || window.location.hostname === 'www.virtualtravelxpos.com') &&
                <Route path="/" exact component={HomeView} />
            )}

              <Route
                path="/meeting-opt-in"
                exact
                component={MeetingOptInView}
              />
              <Route
                path="/print/:firstName/:lastName/:appId"
                render={(props) => {
                  const { firstName, lastName, appId } = props.match.params;
                  return <PrintComponent firstName={firstName} lastName={lastName} appId={appId} />;
                }}
              />

              <Route
                path="/attendee"
                exact
                render={props => <AttendeeView match={props.match} />}
              />
              <Route
                path="/attendee/:id"
                exact
                render={props => <AttendeeView match={props.match} />}
              />

              <Route
                path="/xpo-exhibitor"
                exact
                component={ExhibitorView}
              />
              <Route
                path="/exhibitor"
                exact
                render={props => <LoginView match={props.match} keepUserStorage />}
              />
              <Route path="/profile-image" exact component={ProfileImageView} />
              {((window.location.hostname !== 'virtualtravelxpos.com' && window.location.hostname !== 'www.virtualtravelxpos.com') &&
                <Route
                  path="/"
                  render={() => <AttendeeView match="" />}
                />
              )}
              <Route component={NotFoundView} />
            </Switch>
            {this.state.cookies === 'requiresConsent' && (
              <CookieConsent
                location="top"
                onAccept={this.CookieAccept}
                buttonText={i18n.translate('cookies.consent')}
                cookieName="cookieConsent"
                expires={365}
                containerClasses="cookieConsent"
                contentClasses="cookieContent"
                buttonClasses="cookieBtn"
                debug
                disableStyles
              >
                <p className="cookieText">
                  <span>
                    <FontAwesomeIcon icon={['fas', 'shield-alt']} />
                  </span>
                  {i18n.translate('cookies.message')}
                </p>
                <button onClick={this.CookieDecline} className="cookieOptOut btnInverse">
                  {i18n.translate('cookies.optout')}
                </button>
              </CookieConsent>
            )}
            {demo && (
              <CookieConsent
                location="bottom"
                buttonText={i18n.translate('demo.consent')}
                cookieName="demoConsent"
                expires={365}
                containerClasses="demoConsent"
                contentClasses="cookieContent"
                buttonClasses="demoBtn"
                debug
                disableStyles
              >
                <p className="cookieText">
                  <span>
                    <FontAwesomeIcon icon={['fas', 'bug']} />
                  </span>
                  {i18n.translate('demo.message')}
                </p>
              </CookieConsent>
            )}
          </div>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

AppRouter.propTypes = {
  match: PropTypes.shape(),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

AppRouter.defaultProps = {
  match: {},
  location: {},
};
